import { Toast, ToastBody } from "reactstrap";
import { Btn, Image } from "../../../../../AbstractElements";
import { dynamicImage } from "../../../../../Service/DynamicImage";
import { useState } from "react";
import { TopRightToasts } from "../../../../../Constant";

const TopRightToast = () => {
  const [open, setOpen] = useState(false);
  const toggle = () => {
    setOpen(true);
    setTimeout(() => {
      setOpen(false);
    }, 3000);
  };

  return (
    <>
      <Btn color="primary" onClick={toggle}>{TopRightToasts}</Btn>
      <div className="toast-container position-fixed top-0 end-0 p-3 toast-index toast-rtl">
        <Toast fade isOpen={open}>
          <div className="toast-header toast-img">
            <Image className="rounded me-2" src={dynamicImage("avtar/profile.png")} alt="profile" />
            <strong className="me-auto">Boho theme</strong>
            <small>5 min ago</small>
            <Btn className="btn-close" onClick={() => setOpen(false)}></Btn>
          </div>
          <ToastBody className="toast-dark">Hello, I'm a web-designer.</ToastBody>
        </Toast>
      </div>
    </>
  );
};

export default TopRightToast;
